import { fetchLowStockInventoryInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { connect } from 'react-redux';

import InventoryLowStock from '../../components/Inventories/inventoryLowStock'

function mapStateToProps(state) {
    return {
        inventories: state.inventories.lowStockInventories,
        isLoading: state.inventories.lowStockIsLoading,
        error: state.inventories.lowStockError,
        currentInventory: state.inventories.currentInventory
    };
}

export default connect(mapStateToProps, { fetchLowStockInventoryInventories, selectInventory, resetCurrentInventory })(InventoryLowStock);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryLowStock.jsx